// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__18ZuV","title":"FrontImage_title__2Yb-N"};